import React from "react";
import {
  SEO,
  PageLayout,
  HeroElement,
  FoodMenu,
  CartHOC,
  MenuCartDisplay
} from "../../../../../../packages/components/src";
import { Grid, Dropdown } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import { getPageHeroImage } from "../utils/utils";

export default class extends React.PureComponent {
  render() {
    const { data } = this.props;
    const {
      fishermanBusiness,
      fishermanBusinessWebsitePage,
      allFishermanBusinessMenuSchedule,
      allFishermanBusinessMenuCategory,
      allFishermanBusinessMenuItem,
      allFishermanBusinessMenuModifierSet,
      allFishermanBusinessMenuModifier,
    } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          images={getPageHeroImage({
            options: fishermanBusinessWebsitePage.components,
          })}
        />
        <PageLayout
          hero={
            <HeroElement
              header={"Order Online"}
              tagline={""}
              images={getPageHeroImage({
                options: fishermanBusinessWebsitePage.components,
              })}
              ctas={[fishermanBusiness.ctas.phone]}
              ctaInverted={true}
              ctaColor={"white"}
              containerColor={"primary"}
              textColor={"white"}
              showMultiple={true}
              overlay={true}
              fullWidth={true}
              parallax={false}
              containerAs={"none"}
              height={"100vh"}
              gutter={false}
            />
          }
        >
          <Grid
            stackable={true}
            className={"component-section-container"}
            verticalAlign={"middle"}
            textAlign={"center"}
          >
            <Grid.Column width={"16"} textAlign={"left"}>
              {/*<div>*/}
                {/*<h5>Categories</h5>*/}
                {/*<Dropdown*/}
                  {/*placeholder="Category"*/}
                  {/*search*/}
                  {/*selection*/}
                  {/*options={allFishermanBusinessMenuCategory.nodes.map(({ name }) => ({*/}
                    {/*key: name,*/}
                    {/*value: name,*/}
                    {/*text: name*/}
                  {/*}))}*/}
                {/*/>*/}
              {/*</div>*/}
              {/*<FoodMenu*/}
                {/*menu={{*/}
                  {/*schedules: allFishermanBusinessMenuSchedule.nodes,*/}
                  {/*categories: allFishermanBusinessMenuCategory.nodes,*/}
                  {/*items: allFishermanBusinessMenuItem.nodes,*/}
                  {/*modifierSets: allFishermanBusinessMenuModifierSet.nodes,*/}
                  {/*modifiers: allFishermanBusinessMenuModifier.nodes,*/}
                {/*}}*/}
                {/*header=""*/}
                {/*disableModifiers*/}
                {/*disableSchedules*/}
                {/*categoryDisplayVariant="HorizontalCardRow"*/}
                {/*itemDisplayVariant="HorizontalCard"*/}
                {/*// cart={cart}*/}
              {/*/>*/}
              <CartHOC
                hours={fishermanBusiness.primaryLocation.hours}
                timezone={fishermanBusiness.primaryLocation.timezone}
              >
                {cart => (
                  <div className="food-menu-cart-container">
                    <div>
                      <FoodMenu
                        menu={{
                          schedules: allFishermanBusinessMenuSchedule.nodes,
                          categories: allFishermanBusinessMenuCategory.nodes,
                          items: allFishermanBusinessMenuItem.nodes,
                          modifierSets: allFishermanBusinessMenuModifierSet.nodes,
                          modifiers: allFishermanBusinessMenuModifier.nodes,
                        }}
                        header=""
                        disableModifiers
                        disableSchedules
                        categoryDisplayVariant="HorizontalCardRow"
                        itemDisplayVariant="HorizontalCard"
                        cart={cart}
                      />
                    </div>
                    <MenuCartDisplay
                      cart={cart}
                      menu={{
                        schedules: allFishermanBusinessMenuSchedule.nodes,
                        categories: allFishermanBusinessMenuCategory.nodes,
                        items: allFishermanBusinessMenuItem.nodes,
                        modifierSets: allFishermanBusinessMenuModifierSet.nodes,
                        modifiers: allFishermanBusinessMenuModifier.nodes,
                      }}
                      locationId={173}
                    />
                  </div>
                )}
              </CartHOC>
            </Grid.Column>
          </Grid>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
      primaryLocation {
        timezone
        hours {
          day
          open
          close
          label
        }
      }
      ctas {
        phone {
          text
          link
          internal
        }
      }
    }
    fishermanBusinessWebsitePage(title: { eq: "Menu" }) {
      title
      components {
        fastId
        order
        files {
          file
          altText
          gatsbyFile {
            childImageSharp {
              fluid(maxWidth: 720) {
                aspectRatio
                base64
                src
                srcSet
              }
            }
          }
        }
      }
    }
    allFishermanBusinessMenuSchedule {
      nodes {
        availableDays
        categories
        _id
        name
      }
    }
    allFishermanBusinessMenuCategory {
      nodes {
        items
        name
        _id
      }
    }
    allFishermanBusinessMenuItem {
      nodes {
        modifierSets
        description
        _id
        name
        image
        gatsbyImage {
          childImageSharp {
            fluid(maxWidth: 200) {
              aspectRatio
              base64
              src
              srcSet
            }
          }
        }
        variations {
          _id
          menuItem
          name
          order
          price
        }
      }
    }
    allFishermanBusinessMenuModifierSet {
      nodes {
        _id
        minAllowed
        modifiers
        name
      }
    }
    allFishermanBusinessMenuModifier {
      nodes {
        _id
        name
        price
      }
    }
  }
`;
